import {Selector, State} from "@ngxs/store";
import {PlaylistsReportStateModel} from "@store/report/playlists/playlists-state.model";
import {IPlaylist} from "@interfaces/playlist";
import {Injectable} from "@angular/core";
import {PlaylistsService} from "@services/playlists/playlists.service";
import {Observable} from "rxjs";
import {IResponse} from "@interfaces/response";
import {tap} from "rxjs/operators";
import {NgxsDataRepository} from "@angular-ru/ngxs/repositories";
import {Payload, StateRepository} from "@angular-ru/ngxs/decorators";
import {DataActionWithoutSubscription} from "@shared/functions";

@StateRepository()
@State<PlaylistsReportStateModel>({
    name: 'reportPlaylistTab',
    defaults: {
        currentPage: 1,
        itemsPerPage: 6,
        totalPlaylists: 0,
        loader: false,
        search: '',
        playlists: [],
        order: ''
    }
})


@Injectable()
export class ReportPlaylistsState extends NgxsDataRepository<PlaylistsReportStateModel> {
    constructor(private playlistService: PlaylistsService ) {
        super();
    }

    @Selector([ReportPlaylistsState])
    static getSearch(state: PlaylistsReportStateModel): string {
        return state.search
    }

    @DataActionWithoutSubscription({cancelUncompleted: true})
    fetchPlaylists(): Observable<IResponse<IPlaylist>> {
        const limit = this.ctx.getState().itemsPerPage;
        const skip = limit * (this.ctx.getState().currentPage - 1);
        const search = this.ctx.getState().search;
        const order = this.ctx.getState().order

        this.ctx.patchState({loader: true})
        return this.playlistService.fetchPlaylists({limit, search, skip, order, type: 'main'})
            .pipe(
                tap(data => {
                    const state = this.ctx.getState();
                    this.ctx.setState({...state, playlists: data.rows, totalPlaylists: data.total, loader: false})
                })
            )
    }

    @DataActionWithoutSubscription()
    searchPlaylists(@Payload('[Report playlists] search playlists') search: string): void {
        this.ctx.patchState({search, currentPage: 1})
    }

    @DataActionWithoutSubscription()
    getPlaylistsByPage(@Payload('[Report playlists] get playlists by page') page: number): Observable<any> {
        this.ctx.patchState({currentPage: page})
        return this.fetchPlaylists()
    }

    @DataActionWithoutSubscription()
    setOrderPlaylists(@Payload('[Report playlists] set playlists order') order:string): Observable<any> {
        this.ctx.patchState({order})
        return this.fetchPlaylists();
    }
}
